export const DEFAULT_INITIATE_PROPOSAL_FORM_ID = 'default-initiate-proposal-form';
